<template>
    <div
        v-if="isOpen"
        :class="modalClass"
        @click="allowEscape ? closeModal() : null">
        <div :class="containerClass" @click.stop>
            <button v-if="enableCloseButton" class="modal__close-btn" @click="closeModal()"><img src="@/assets/images/decoration/cross-shop.svg"></button>
            <div class="modal__content">
                <slot></slot>
            </div>
            <div class="modal__actions">
                <button
                    v-if="allowCancel"
                    @click="closeModal"
                    v-text="cancelButtonText"
                    class="btn btn--primary">
                </button>
                <slot name="actions-prefix"></slot>
                <slot name="actions-suffix"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    data() {
        return {
            isOpen: true,
        };
    },
    props: {
        allowCancel: {
            default: true,
            type: Boolean,
        },
        cancelButtonText: {
            default: 'Cancel',
            type: String,
        },
        enableFullScreen: {
            default: false,
            type: Boolean,
        },
        enableCloseButton: {
            default: true,
            type: Boolean,
        },
        allowEscape: {
            default: true,
            type: Boolean,
        },
        customClass: {
            default: '',
            type: String,
        },
    },
    methods: {
        closeModal() {
            this.isOpen = false;

            // Emit the closed event so the modal can be destroyed by the parent component
            this.$emit('closed');
        },
    },
    computed: {
        modalClass() {
            return this.enableFullScreen ? 'modal modal--full-screen' : 'modal';
        },
        containerClass() {
            return `modal__container container ${this.customClass}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.modal {
    background: rgba(1, 1, 1, 0.5);
    @apply flex items-center justify-center w-screen h-screen fixed max-w-full top-0 left-0 z-999;
    &__container {
        @apply bg-white p-4 relative mx-4;
    }
    &__content {
        @apply p-3;
    }
    &__actions {
        @apply w-full flex flex-wrap items-center justify-center pb-4;
    }
    &--full-screen {
        .modal {
            &__container {
                @apply m-4;
                height: 90vh;
            }
        }
    }
    &__close-btn {
        width: 18px;
        height: 18px;
        line-height: 29px;
        top: 20px;
        right: 18px;
        color: theme('colors.shop.darkGrey');
        text-align: center;
        position: absolute;
        z-index: 60;
        &:hover {
            color: black;
        }
    }
}
</style>
